import React, { useEffect, memo } from 'react';
import NProgress from 'nprogress';
import Router from 'next/router';
const CONFIG = {
  color: '#589F39',
  stopDelayMs: 200,
  startPosition: 0.5,
  height: 3
};
export const progressBarStyles = "p1y0i0ht";
const NextNProgress = memo(() => {
  let timer = null;
  const {
    stopDelayMs,
    startPosition
  } = CONFIG;
  const routeChangeStart = () => {
    NProgress.set(startPosition);
    NProgress.start();
  };
  const routeChangeEnd = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      NProgress.done(true);
    }, stopDelayMs);
  };
  useEffect(() => {
    Router.events.on('routeChangeStart', routeChangeStart);
    Router.events.on('routeChangeComplete', routeChangeEnd);
    Router.events.on('routeChangeError', routeChangeEnd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // just a hidden progress bar as a placeholder
  return <progress hidden />;
});
export default NextNProgress;

require("./ProgressBar.linaria.module.css");